import React from 'react';
import moment from 'moment';
import ProgressSpinner from '@avtechsoftware/react-component-library/src/components/common/ProgressSpinner';
import ErrorBanner from '@avtechsoftware/react-component-library/src/components/common/ErrorBanner';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import RemoteService from '@avtechsoftware/ra-javascript-utilities/src/utilities/remoteService/remoteService';
import OrdersListRow from './OrdersListRow/OrdersListRow';

import envConfig from '../../../envConfig';
import CrmOrder from '../../../classes/CrmOrder';
import OrderDateRange from './OrderStatusFactory/OrdersListDateRange';
import RaaAuthenticatedRemoteService from '../../../utility/RaaAuthenticatedRemoteService';

class OrdersList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dataLoading: true,
      error: false,
      orders: [],
    };
    this.handleRowClick = this.handleRowClick.bind(this);
    this.handleDismissError = this.handleDismissError.bind(this);
    this.handleTimeRangeUpdate = this.handleTimeRangeUpdate.bind(this);
    this.getOrders = this.getOrders.bind(this);
  }

  componentDidMount() {
    this.getOrders(moment().unix() - 7889229, moment().unix());
  }

  getOrders(start, end) {
    this.setState({ dataLoading: true });
    RaaAuthenticatedRemoteService.globalInstance().get(`${envConfig.apiUrl}/api/v1/orders/?startDate=${start}&endDate=${end}`)
      .then((response) => {
        this.setState({
          orders: response.ordersList.map((order) => new CrmOrder(
            order.id,
            order.createdAt,
            order.orderNumber,
            order.grandTotal,
            order.shippingTimestamp,
            order.shippingStatus,
            order.poNumber,
            order.paymentStatus,
            order.shipmentList,
            order.currency,
            order.crmOrgId,
          )),
        });
      }).catch((e) => {
        if (e.name === RemoteService.Errors.ForbiddenError) {
          window.location.assign(`${envConfig.raaUrl}/gateway`);
        }
        this.setState({ error: true });
      })
      .finally(() => {
        this.setState({ dataLoading: false });
      });
  }

  handleTimeRangeUpdate(e) {
    const { value } = e.target;
    const startOfYear = moment().tz('America/New_York').startOf('year').unix();
    let startTimestamp = moment().unix() - 7889229;
    let endTimestamp = moment().unix();
    switch (parseInt(value, 10)) {
      case OrderDateRange.THIS_YEAR:
        startTimestamp = startOfYear;
        break;
      case OrderDateRange.LAST_YEAR:
        startTimestamp = moment.unix(startOfYear).subtract(1, 'years').unix();
        endTimestamp = startOfYear;
        break;
      case OrderDateRange.TWO_YEARS_AGO:
        startTimestamp = moment.unix(startOfYear).subtract(2, 'years').unix();
        endTimestamp = moment.unix(startOfYear).subtract(1, 'years').unix();
        break;
      case OrderDateRange.THREE_YEARS_AGO:
        startTimestamp = moment.unix(startOfYear).subtract(3, 'years').unix();
        endTimestamp = moment.unix(startOfYear).subtract(2, 'years').unix();
        break;
      case OrderDateRange.FOUR_YEARS_AGO:
        startTimestamp = moment.unix(startOfYear).subtract(4, 'years').unix();
        endTimestamp = moment.unix(startOfYear).subtract(3, 'years').unix();
        break;
      case OrderDateRange.FIVE_YEARS_AGO:
        startTimestamp = moment.unix(startOfYear).subtract(5, 'years').unix();
        endTimestamp = moment.unix(startOfYear).subtract(4, 'years').unix();
        break;
      default:
        break;
    }
    this.getOrders(startTimestamp, endTimestamp);
  }

  // eslint-disable-next-line class-methods-use-this
  handleRowClick(orderNumber) {
    const { history } = this.props;
    history.push(`/s/order/details/${orderNumber}`);
  }

  handleDismissError() {
    this.setState({ error: false });
  }

  render() {
    const { dataLoading, error, orders } = this.state;
    return (
      <div className="container-fluid">
        {error && (
        <div className="row">
          <div className="col">
            <ErrorBanner onCloseError={this.handleDismissError}>
              Unexpected Error retrieving orders.
            </ErrorBanner>
          </div>
        </div>
        )}
        <div className="row">
          <div className="col-auto">
            <select className="form-control" onChange={this.handleTimeRangeUpdate}>
              <option value={OrderDateRange.LAST_THREE_MONTHS}>Last 3 Months</option>
              <option value={OrderDateRange.THIS_YEAR}>{moment().year()}</option>
              <option value={OrderDateRange.LAST_YEAR}>{moment().year() - 1}</option>
              <option value={OrderDateRange.TWO_YEARS_AGO}>{moment().year() - 2}</option>
              <option value={OrderDateRange.THREE_YEARS_AGO}>{moment().year() - 3}</option>
              <option value={OrderDateRange.FOUR_YEARS_AGO}>{moment().year() - 4}</option>
              <option value={OrderDateRange.FIVE_YEARS_AGO}>{moment().year() - 5}</option>
            </select>
          </div>
        </div>
        <table className="table table-sm table-striped mt-3 table-hover ">
          <thead>
            <tr>
              <th>Created</th>
              <th>Order Number</th>
              <th>Total</th>
              <th>Status</th>
              <th>P.O.</th>
              <th>Payment</th>
            </tr>
          </thead>
          {!dataLoading
                        && (
                        <tbody>
                          {orders.map((order, index) => (
                            <OrdersListRow
                              order={order}
                              onRowClick={
                                        /* istanbul ignore next */
                                        () => this.handleRowClick(`ORD-${order.id}-${(order.id + order.crmOrgId)}`)
                                    }
                              key={index}
                            />
                          ))}
                        </tbody>
                        )}
        </table>
        {dataLoading && (
        <div className="row d-flex justify-content-center mt-5">
          <div><ProgressSpinner progressText="Loading..." /></div>
        </div>
        )}
      </div>
    );
  }
}

OrdersList.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export { OrdersList };

export default withRouter((OrdersList));
